export default __webpack_public_path__ + "static/media/85t.78d67a08.jpg";